import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { typesofUsers } from "../../config";

const VERIFICATION_INTRO_TEXT =
  "Some information may be hidden based on your role or company policies.";
const VERIFICATION_FOLLOW_UP_TEXT =
  "If you believe you need access to information you can't see, please contact your manager.";

const allowedRolesForVerificationMessage = [
  typesofUsers.agent,
  typesofUsers.manager,
  typesofUsers.subscriberUser,
  typesofUsers.subscriberAdmin,
];

type VerificationInfoMessageProps = {
  userRole?: string;
  show?: boolean;
  className?: string;
};

const VerificationInfoMessage: React.FC<VerificationInfoMessageProps> = ({
  userRole,
  show = true,
  className = "",
}) => {
  const normalizedRole = userRole?.toLowerCase();
  const isCustomRole = normalizedRole?.includes("custom");

  if (
    !show ||
    !userRole ||
    (!allowedRolesForVerificationMessage.includes(userRole) && !isCustomRole)
  ) {
    return null;
  }

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
        marginTop: "8px",
        padding: "10px 12px",
        borderRadius: "6px",
        border: "1px solid #cce9f2",
        backgroundColor: "#ecfbff",
        color: "#0b5d80",
        fontSize: "12px",
        lineHeight: "18px",
      }}
    >
      <InfoOutlinedIcon fontSize="small" />
      <div style={{ display: "flex", flexDirection: "column" }}>
        <strong style={{ fontSize: "12px", lineHeight: "18px" }}>
          {VERIFICATION_INTRO_TEXT}
        </strong>
        <span>{VERIFICATION_FOLLOW_UP_TEXT}</span>
      </div>
    </div>
  );
};

export default VerificationInfoMessage;
